import { render, staticRenderFns } from "./RouteProgressDummy.vue?vue&type=template&id=670efe71&scoped=true&"
import script from "./RouteProgressDummy.vue?vue&type=script&lang=js&"
export * from "./RouteProgressDummy.vue?vue&type=script&lang=js&"
import style0 from "./RouteProgressDummy.vue?vue&type=style&index=0&id=670efe71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670efe71",
  null
  
)

export default component.exports